import { DeferredQueryInput, QueryV1Input } from '../../../types/J1QL';
import { LoadMoreOrderByOptions } from '../../types';
import { DeferredJ1QL } from '../../graphql/queries/J1';
import useDeferredJ1QLQuery from './useDeferredJ1QLQuery';
import useQueryV1InStandard from './useQueryV1InStandard';

const useJ1QLSortingPaginationQuery = (
  queryV1Input: QueryV1Input,
  standardId: string = '',
  skip: boolean = false
) => {
  const queryV1InputToHook: DeferredQueryInput = { ...queryV1Input };

  const dataPath = 'queryV1';
  const cursorPath = 'queryV1.cursor';

  let isQueryInStandard: boolean = false;
  if (standardId) {
    isQueryInStandard = true;
  }

  const {
    fetchMore: fetchMoreDeferredQuery,
    setOrderByNode: setOrderByNodeDeferredQuery,
    ...deferredQueryOutput
  } = useDeferredJ1QLQuery(DeferredJ1QL, {
    input: queryV1InputToHook,
    dataPath,
    cursorPath,
    skip: isQueryInStandard || skip,
  });

  const {
    fetchMore: fetchMoreQueryV1InStandard,
    setOrderByNode: setOrderByNodeQueryV1InStandard,
    ...queryV1InStandardOutput
  } = useQueryV1InStandard({
    queryV1Input: queryV1InputToHook,
    standardId,
    skip: !isQueryInStandard || skip,
  });

  const loadMoreOrderByDeferredJ1QL = async (
    options: LoadMoreOrderByOptions
  ) => {
    if (options.orderBy) {
      setOrderByNodeDeferredQuery(options.orderBy);
    } else {
      await fetchMoreDeferredQuery();
    }
  };

  const loadMoreOrderByQueryV1InStandard = async (
    options: LoadMoreOrderByOptions
  ) => {
    if (options.orderBy) {
      setOrderByNodeQueryV1InStandard(options.orderBy);
    } else {
      await fetchMoreQueryV1InStandard();
    }
  };

  if (isQueryInStandard) {
    return {
      ...queryV1InStandardOutput,
      loadMore: fetchMoreQueryV1InStandard,
      loadMoreOrderBy: loadMoreOrderByQueryV1InStandard,
    };
  } else {
    return {
      ...deferredQueryOutput,
      loadMore: fetchMoreDeferredQuery,
      loadMoreOrderBy: loadMoreOrderByDeferredJ1QL,
    };
  }
};

export default useJ1QLSortingPaginationQuery;
